module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-bg-2-b9c8b65c1ba75e72760e6353cd3f62ef.png";